






















































































import Vue from 'vue';
import { mapGetters } from 'vuex';
import { errorToMessage } from '../../../core/utils/errors';
import RefreshData from '@/web/mixins/refreshData';
import { getStudioURL } from '@/web/router/custom-domain-utils';
import StudioCommunityGroupCard from '@/web/components/community/StudioCommunityGroupCard.vue';
import CommunityNotifications from '@/web/components/community/CommunityNotifications.vue';
import CommunityNotificationsList from '@/web/components/community/CommunityNotificationsList.vue';

export default Vue.extend({
  name: 'StudioCommunity',
  mixins: [RefreshData],
  components: {
    StudioCommunityGroupCard,
    CommunityNotifications,
    CommunityNotificationsList,
  },
  computed: {
    ...mapGetters({
      studentMagicCode: 'user/studentMagicCode',
      interactAsStudio: 'community/interactAsStudio',
    }),
    studioURL() {
      return getStudioURL(this.$route);
    },
    hasGroups() {
      return this.groups?.length > 0;
    },
  },
  data() {
    return {
      isLoading: true,
      groups: [],
    };
  },
  methods: {
    async loadData() {
      this.isLoading = true;
      try {
        this.groups = await this.$store.dispatch('community/loadStudioGroups', {
          studioURL: this.studioURL,
        });
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: this.$t('NOTIFICATIONS.TITLE.ERROR') as string,
          text: errorToMessage(error?.response, `Request failed: ${error}`),
          duration: -1,
        });
      } finally {
        this.isLoading = false;
      }
    },
  },
  mounted() {
    this.loadData();
  },
});
